import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prev",
  "use": "icon-prev-usage",
  "viewBox": "0 0 66 14",
  "content": "<symbol viewBox=\"0 0 66 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-prev\">\r\n<rect x=\"0.795654\" y=\"11.6699\" width=\"64.6338\" height=\"1.79538\" fill=\"currentColor\" />\r\n<rect x=\"0.897949\" y=\"12.0605\" width=\"17.0561\" height=\"1.79538\" transform=\"rotate(-45 0.897949 12.0605)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol